























































































































































































































import Vue from 'vue';
import Parallax from 'vue-parallaxy';
import axios from 'axios';

export default Vue.extend({
  components: {
    Parallax,
  },
  data() {
    return {
      email: '',
      isVisible: false,
      lookbookCinture: false,
      lookbookBretelle: false,
      instaPics: [],
      access_token: '9476459575.1677ed0.efe86848c0584c33a9455f23f91511b1',
      url: 'https://api.instagram.com/v1/users/self/media/recent/',
    };
  },
  methods: {
    onceHandler(e: any) {
      if ( e.type === 'progress' && e.percentInView >= 0.2 ) {
        e.target.element.classList.add('in-view');
      }
    },
    openLookBookCinture() {
      this.lookbookCinture = true;
    },
    closeLookBookCinture() {
      this.lookbookCinture = false;
      document.getElementById('custom-cursor')!.classList.remove('close');
    },
    openLookBookBretelle() {
      this.lookbookBretelle = true;
    },
    closeLookBookBretelle() {
      this.lookbookBretelle = false;
      document.getElementById('custom-cursor')!.classList.remove('close');
    },
    getPics() {
      axios.get(this.url + '?access_token=' + this.access_token).then((response: any) => {
        const items = response.data.data;
        this.instaPics = items.slice(0, 6);
      });
    },
    iscrizione() {
      if ( this.email === '' ) {
        this.$toast.open({
          message: 'Il campo email è obbligatorio.',
          type: 'is-danger',
        });
        return;
      }
      this.$toast.open({
        message: 'Iscrizione avvenuta con successo!',
        type: 'is-success',
      });
    },
  },
  created() {
    this.getPics();
  },
});
